<template>
  <v-row
    no-gutters
    class="div-dos-botoes-da-home"
    id="div-dos-botoes-da-home"
    justify="center"
  >
    <div
      class="regular-shadow student-homescreen-button"
      @click="collapse = !collapse"
    >
      <v-list
        flat
        class="student-homescreen-items-list"
        id="student-homescreen-items-list"
      >
        <v-list-item>
          <div class="white--text mx-auto">
            <img v-if="type === 'home'"
              src="@/assets/icone_casa_home_school.svg"
              style="width: 42px; margin-top: -6px;"
            />
            <img v-else
              src="@/assets_aluno/icone_chapeu_formatura.svg"
              style="width: 42px; margin-top: -6px;"
            />
            <br />
            <div class="texto-do-botao-grande">
              Aula particular
            </div>
            <span>{{ subtitle }}</span>
          </div>
        </v-list-item>

        <v-list-group v-model="collapse" v-show="collapse" append-icon="" eager>
          <v-list-item
            v-for="subject in subjects"
            :key="subject.name"
            class="student-homescreen-v-list-item"
            @click="onSubjectClick(subject)"
          >
            <div class="student-homescreen-item">
              {{ subject.name }}
            </div>
          </v-list-item>
        </v-list-group>
      </v-list>
    </div>
  </v-row>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  props: {
    subjects: Array,
    subtitle: String,
    type: String,
  },
  data() {
    return {
      collapse: false
    };
  },
  computed: {},
  methods: {
    ...mapMutations(["setSelectedSubject"]),
    onSubjectClick(subject) {
      this.setSelectedSubject(subject);
      this.$emit('positive')
    }
  }
};
</script>

<style scoped>
.div-dos-botoes-da-home {
  margin-top: 0;
  padding: 0 46px;
}
.regular-shadow {
  box-shadow: 0 5px 9px 2px rgba(26, 0, 76, 0.8);
  transition: 0.02s ease-out;
}
.regular-shadow:hover {
  box-shadow: 0 7px 18px 3px rgba(26, 0, 76, 0.6);
}
.regular-shadow:active {
  box-shadow: 0 0 2px 1px rgba(26, 0, 76, 0.8), 0 0 0 rgba(0, 0, 0, 0);
}
.student-homescreen-button {
  border: 1px solid #ffffff;
  padding: 32px 16px;
  width: 100%;
  max-width: 420px;
  margin-bottom: 30px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 200;
  text-align: center;
  text-transform: uppercase;
  line-height: 1.5;
  letter-spacing: 3px;
  cursor: pointer;
}
.student-homescreen-button:active{
  transform: scale(0.98);
  transition: 0.1s ease-out;
}
.student-homescreen-button span {
  color: #44ff99;
  font-size: 28px;
  font-weight: 900;
  letter-spacing: 6px;
  line-height: 1.3;
}
.texto-do-botao-grande{
  letter-spacing: 4px;
  font-size: 16px;
}
.student-homescreen-items-list {
  background-color: rgba(0, 0, 0, 0);
  font-size: 16px;
  cursor: pointer;
}
.v-list-item.student-homescreen-v-list-item {
  min-height: 64px;
}
.student-homescreen-item {
  width: 100%;
  text-align: center;
  color: #ffffff;
  font-weight: 900;
  letter-spacing: 3px;
}
.student-homescreen-item-divider {
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  border-bottom: none;
  width: 70%;
  margin: 0 auto;
}
</style>
